import { render, staticRenderFns } from "./MyOrganization.vue?vue&type=template&id=3e7744da&scoped=true&"
import script from "./MyOrganization.vue?vue&type=script&lang=js&"
export * from "./MyOrganization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e7744da",
  null
  
)

export default component.exports